<script lang="ts" setup>
import {defineProps} from "vue";
import type {Source} from "@/domain/type/source.type.ts";
import LinkToCompanyAction from "@/components/Cards/Action/LinkToCompanyAction.vue";
import CreateAction from "@/components/Cards/Action/CreateAction.vue";
import TooManyAction from "@/components/Cards/Action/TooManyAction.vue";
import {SyncState} from "@/domain/type/synchro.type.ts";
import type {AbstractEntity} from "@/domain/entity/AbstractEntity.ts";
import {EntityAction} from "@/domain/type/entity.type.ts";
import FusionAction from "@/components/Cards/Action/FusionAction.vue";

const props = defineProps<{
  srcLeft: Source,
  srcRight: Source,
  entity: AbstractEntity,
  actions: string[],
  ownerId: string
}>();

function showLinkToOwner(): boolean {
  return props.entity.state === SyncState.OTHER_OWNER
    && props.actions.includes(EntityAction.linkToOwner);
}

function showCreateAction(): boolean {
  return props.entity.state === SyncState.MISSING
    && props.actions.includes(EntityAction.create);
}

function showTooManyAction(): boolean {
  return props.entity.state === SyncState.TOO_MANY
    && props.actions.includes(EntityAction.tooMany);
}

function showFusionAction(): boolean {
  return props.entity.state === SyncState.DIFF
    && props.actions.includes(EntityAction.fusion);
}

function showSuccess(): boolean {
  return props.entity.state === SyncState.OK
    && props.actions.includes(EntityAction.success);
}

</script>

<template>
  <link-to-company-action v-if="showLinkToOwner()" :entityUuid="entity.uuid" :src-right="srcRight"/>
  <create-action v-else-if="showCreateAction()" :entity="entity" :src-right="srcRight"/>
  <too-many-action v-else-if="showTooManyAction()" :src-right="srcRight"/>
  <fusion-action v-else-if="showFusionAction()" :entity="entity"/>
  <fusion-action v-else-if="showSuccess()" :entity="entity"/>
</template>

<style scoped>
</style>
